import React from 'react'

class Introduce extends React.Component {
  render () {
    return (
      <h6>monkey introduce</h6>
    )
  }
}

export default Introduce


// WEBPACK FOOTER //
// ./src/views/introduce/Introduce.js